export type TRawPrice = [number, number];

export type TFilterPriceState = Array<number | null>;

export function isFilterPriceRangeReady(
  minPrice?: number,
  maxPrice?: number,
  histogram?: Record<string, number>,
): boolean {
  return Number.isFinite(minPrice) && Number.isFinite(maxPrice) && histogram !== undefined;
}

export type TFilterPriceBounds = {
  min: number;
  max: number;
};

export function getFilterPriceBounds(minPrice?: number, maxPrice?: number): TFilterPriceBounds | null {
  if (!Number.isFinite(minPrice) || !Number.isFinite(maxPrice)) {
    return null;
  }

  return { min: minPrice as number, max: maxPrice as number };
}

export function getFilterPriceRawValueFromState(
  statePrice: TFilterPriceState,
  bounds: TFilterPriceBounds | null,
): TRawPrice {
  if (!bounds) {
    return [Number.NaN, Number.NaN];
  }

  const [startPrice, endPrice] = statePrice;

  return [startPrice !== null ? startPrice : bounds.min, endPrice !== null ? endPrice : bounds.max];
}

export function toFilterPriceState(rawValue: TRawPrice, bounds: TFilterPriceBounds): TFilterPriceState {
  return [rawValue[0] === bounds.min ? null : rawValue[0], rawValue[1] === bounds.max ? null : rawValue[1]];
}
